import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListStyles.container = {
    ...productListStyles.container,
    css: css`
        ${productListStyles.container?.css}
        border-top: none;
    `,
};

productListStyles.lineGridItem = {
    ...productListStyles.lineGridItem,
    css: css`
        ${productListStyles.lineGridItem?.css}
        border: 1px solid ${getColor("common.border")};
        border-radius: 4px;
        padding: 16px;
    `,
};
